export default class Endereco {
  constructor(id = '', telefone = '', email = '', contato_urgencia = '') {
    this.id = id;
    this.telefone = telefone;
    this.email = email;
    this.contato_urgencia = contato_urgencia;
  }
}
